import type { ReactNode } from 'react';
import { Img } from './Img.tsx';
import { Eyebrow } from './ui.tsx';

/**
 * Internal-page hero with a darkened background image.
 * The background image is the LCP element on these pages, so it is eager with
 * high fetch priority and explicit dimensions (no CLS).
 */
export function PageHero({
  image,
  imageAlt,
  width,
  height,
  eyebrow,
  heading,
  lead,
}: {
  image: string;
  imageAlt: string;
  width: number;
  height: number;
  eyebrow: string;
  heading: ReactNode;
  lead: string;
}) {
  return (
    <section className="page-hero">
      <div className="page-hero__bg">
        <Img
          src={image}
          alt={imageAlt}
          width={width}
          height={height}
          priority
        />
      </div>
      <div className="container">
        <div className="page-hero__content">
          <Eyebrow className="fade-in">{eyebrow}</Eyebrow>
          <h1 className="fade-in fade-in-delay-1">{heading}</h1>
          <p className="lead fade-in fade-in-delay-2">{lead}</p>
        </div>
      </div>
    </section>
  );
}
